(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AnagraficaIterlegisDeleteController', AnagraficaIterlegisDeleteController);

            AnagraficaIterlegisDeleteController.$inject = ['$uibModalInstance', 'entity', 'AnagraficaIterlegis'];

    function AnagraficaIterlegisDeleteController($uibModalInstance, entity, AnagraficaIterlegis) {
        var vm = this;

        vm.anagraficaIterlegis = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AnagraficaIterlegis.delete({id: id},
                    function () {
                        $uibModalInstance.close(true);
                    });
        }
    }
})();
